/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Menu,
  Text,
  Input,
  CloseButton,
  Select,
  Button,
} from "@mantine/core";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineSearch } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./AppHeader.module.css";
import { assetsPrefix } from "../../utilities/utilities";
import { selectUserData } from "../../redux/selectors";
import { DoorExit, Exchange, Lock } from "tabler-icons-react";
import { deleteCookie, getCookiesSession } from "../../cookiesSession";
import axios from "axios";
import { changeUserRole } from "../../utilities/apis/users";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { setCookiesSession } from "../../cookiesSession";
import actions from "../../redux/actions";
import {
  IconArrowBack,
  IconChartBar,
  IconUsersGroup,
} from "@tabler/icons-react";

const AppHeader = ({ hide = false }) => {
  const navigate = useNavigate();
  let userData = null;

  try {
    const cookie = getCookiesSession("masterResult");

    userData = cookie ? JSON.parse(cookie)?.user : null;
  } catch (e) {
    console.error("Invalid masterResult cookie", e);
  }

  useEffect(() => {
    if (!userData) {
      navigate("/app/login", {
        replace: true,
      });
    }
  }, [userData, navigate]);

  if (!userData) {
    return null;
  }

  const [opened, setOpened] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser?.loginAs ?? null;
  const roles = currentUser?.userRole ?? [];
  const location = useLocation();
  const hideLogo = location.pathname === "/app/choose_manager";
  const logoutHandler = () => {
    deleteCookie("LawSignaUserDataMaster");
    deleteCookie("masterResult");
    window.location = process.env.REACT_APP_LANDING_PAGE_URL;
  };
  const handleRoleChange = async (value) => {
    if (!value) return;
    try {
      const resp = await apiWrapWithErrorWithData(changeUserRole(value));
      // console.log(resp);
      if (resp?.success && resp?.result?.token && resp?.result?.user) {
        // console.log("dispatch");
        //  setConfigs((prevState) => ({
        //    ...prevState,
        //    loading: loadingStates.NO_ACTIVE_REQUEST,
        //  }));
        setCookiesSession(
          "LawSignaUserDataMaster",
          JSON.stringify(resp.result),
          2,
        );
        dispatch({
          type: actions.SET_USER_DATA,
          payload: resp.result.user,
        });
        // navigate("/app/");
        // setTimeout(() => {
        //   navigate("/app/agreements_manager");
        // }, 500);
        navigate(0);
      }
      // Reload the page
    } catch (error) {
      console.error("Error while switching roles:", error);
      // Handle error if needed
    }
  };

  return (
    <div className={styles.headerContainer}>
      {/* {!hideLogo ? (
        <img
          className={styles.logo}
          src={`${assetsPrefix}/images/SecondaryLogo.png`}
          alt="LawSigna"
        />
      ) : (
        <div className="flex items-center"></div>
      )} */}
      {/*       
      <img 
        className={styles.logo}
        src={`${assetsPrefix}/images/SecondaryLogo.png`}
        style={{ visibility: hideLogo ? 'hidden' : 'visible' }} 
        alt="Logo" 
      />
       <Text
        style={{
          padding: "3px 10px",
          borderRadius: "999px",
          border: "1px solid #d1d5db",
          backgroundColor: "#edeeef",
          fontSize: "0.80rem",
          fontWeight: 600,
          fontFamily: "Cinzel",
          textTransform: "none",
          visibility: hideLogo ? 'hidden' : 'visible'
        }}
      >
        Contracts Studio
      </Text> */}

      <div className={styles.logoSection}>
        <img
          className={styles.logo}
          src={`${assetsPrefix}/images/SecondaryLogo.png`}
          style={{ visibility: hideLogo ? "hidden" : "visible" }}
          alt="Logo"
        />
        <Text
          className={styles.productBadge}
          style={{ visibility: hideLogo ? "hidden" : "visible" }}
        >
          Contracts Studio
        </Text>
      </div>

      <div className={styles.rightSection}>
        {/* <Select
          required
          className="max-w-lg"
          label="Select Role"
          placeholder="Select Role to login as"
        
        /> */}

        {/* <Input
          icon={<AiOutlineSearch />}
          value={searchInput}
          rightSection={
            <CloseButton
              onClick={() => {
                setSearchInput("");
                navigate("/app");
              }}
            />
          }
          placeholder="Search"
          className="mx-3"
          onChange={(e) => {
            const input = e.target.value;
            input.length > 2
              ? navigate(`/app/search/${input}`)
              : navigate("/app");
            setSearchInput(input);
          }}
        /> */}

        {userData?.isSystemAdmin === 1 &&
          (window.location.pathname.includes("/team-manager") ||
            window.location.pathname.includes("/system-analytics")) && (
            <Button
              className={styles.headerButton}
              onClick={() => navigate("/app/choose_manager")}
            >
              <IconArrowBack size={20} />
              <span style={{ marginLeft: "8px" }}>Back To Main</span>
            </Button>
          )}

        {userData?.isSystemAdmin === 1 &&
          !window.location.pathname.includes("/system-analytics") && (
            <Button
              onClick={() => navigate("/system-analytics")}
              className={styles.headerButton}
            >
              <IconChartBar size={20} />
              <span style={{ marginLeft: "8px" }}>Analytics</span>
            </Button>
          )}
        {userData?.isSystemAdmin === 1 &&
          !window.location.pathname.includes("/team-manager") && (
            <Button
              onClick={() => navigate("/team-manager")}
              className={styles.headerButton}
            >
              <IconUsersGroup size={20} />
              <span style={{ marginLeft: "8px" }}>Team Manager</span>
            </Button>
          )}
        {!window.location.pathname.includes("/app/choose_manager") &&
          !window.location.pathname.includes("/team-manager") &&
          !window.location.pathname.includes("/system-analytics") && (
            <Select
              className={styles.roleSelect}
              radius="md"
              size="sm"
              searchable
              placeholder="Change Role"
              data={roles.map((role) => ({
                label: role.name,
                value: String(role.id),
                pass: role,
              }))}
              value={loginAs?.id ? String(loginAs.id) : null}
              onChange={(pass) => handleRoleChange(pass)}
            />
          )}
        <Menu width={280} shadow="lg" radius={16} position="bottom-end">
          <Menu.Target>
            <div
              onClick={() => {
                setOpened(!opened);
              }}
              className={styles.userCard}
            >
              {userData?.picture?.length ? (
                <Avatar size={42} radius="xl" src={userData.picture} />
              ) : (
                <Avatar size={42} radius="xl">
                  {userData?.name?.[0]?.toUpperCase() || "U"}
                </Avatar>
              )}
              <div className={styles.userInfo}>
                <Text className={styles.userName}>{userData?.name || ""}</Text>

                <Text className={styles.userEmail}>
                  {userData?.email || ""}
                </Text>
              </div>
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() => navigate("/app/choose_manager")}
              icon={<Exchange size={14} />}
            >
              Choose Manager
            </Menu.Item>
            <Menu.Item
              onClick={() => navigate("/app/updatePassword")}
              icon={<Lock size={14} />}
            >
              Update Password
            </Menu.Item>
            <Menu.Item onClick={logoutHandler} icon={<DoorExit size={14} />}>
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </div>
  );
};

export default AppHeader;
